import React, { useEffect, useContext } from "react";
import { StoreContext } from "../../../Store/Provider";
import { getUserData, localStoragekey } from "../../Common/Utility/Utils";
import { PropagateLoader } from "react-spinners";
import { routeConstant } from "../../../Route/utils/routeConstant";
import { useNavigate } from "react-router-dom";

function LoadingComp(props) {
  const context = useContext(StoreContext);
  const history = useNavigate();

  useEffect(() => {
    getUserData(localStoragekey)
      .then((res) => {
        context.setIsUserLogin(true);
        history(routeConstant.BlogSFL);
      })
      .catch((err) => {
        console.log("error section", err);
        context.setIsUserLogin(false);
        history(routeConstant.BlogSFL);
      });
  }, []);
  return (
    <div className="loadingClass">
      <PropagateLoader
        color={"rgba(var(--text-heading-dark))"}
        size={"1.5rem"}
      />
    </div>
  );
}

export default LoadingComp;
